/**
 * Service: AuditTrailColumnGenerator
 */
angular.module('acme.common.service.auditTrailColumnGenerator', [])
.service('AuditTrailColumnGenerator', ['$filter', function ($filter) {

  return {
    /**
     * Determines style that a cell should take
     * 
     * @returns  {Function} 
     */
    getCellStyle: function () {

      return function (params) {
          var style = {},
              column = params.column.colId.toString(),
              row = params.node.childIndex.toString(),
              key = row + column;
          
          if(params.data['col'+[column]].op === 'replaced') {
            style['background-color'] = '#FADD66';
          } else if (params.data['col'+column].op === 'removed') {
            style['background-color'] = '#F9B8B7';
            style['text-decoration'] = 'line-through';
          } else {
            style = '';
          }
          
          return style;
      };

    },
    
    /**
     * Determines how the cell values should render
     * 
     * @returns  {Function} 
     */
    getCellRenderer: function () {

      return  function (params) {
        var result = '',
            column = params.column.colId.toString(),
            row = params.node.childIndex.toString(),
            format = params.data['col'+[column]].format,
            value = params.data['col'+[column]].value,
            key = row + column,
            res;
        switch (format) {
          case 'boolean':
            if (value === false) {
              res = 'No';
            } else if (value === true) {
              res = 'Yes';
            }
            break;
          case 'currency':
            res = $filter('currency')(value);
            break;
          case 'percent':
            res = Number(value) + '%';
            break;
          case 'value':
            res = Number(value).toString();
            break;
          default:
            res = value;

        }
        return res;
      };
    }
    
  };
  
}]);